// picker-outer-v2.js — the two behaviors specific to the Picker-Outer buy box:
//
//  1. One-way reveal: the bundler starts collapsed to tier 1
//     (picker-outer-v2.css hides .koala-deal__tiers__list > li:nth-child(n+2));
//     clicking "+ ADD MORE AND SAVE" adds .pov2--expanded to the section root,
//     which shows tiers 2/3 and hides the link. State lives on the section
//     root, so Koala re-renders can't re-collapse the tiers.
//
//  2. Homepage-only tier-1 copy override: Koala server-renders the tier
//     title/subtitle from its deal config, which the PDP and /pages/connection
//     share — so the design's "Pick your Can" copy is rewritten client-side,
//     scoped to this section. Koala hydrates after DOMContentLoaded and can
//     re-render wholesale, so we observe document.body (same pattern as
//     formatKoalaPrices in flash-forward.js) and re-apply idempotently.
//
// Everything is scoped to the .pov2 root; on pages without it this is a no-op.
document.addEventListener("DOMContentLoaded", function () {
  const root = document.querySelector(".pov2");
  if (!root) return;

  const reveal = root.querySelector(".pov2__reveal");
  if (reveal) {
    reveal.addEventListener("click", function () {
      root.classList.add("pov2--expanded");
      // Revealing implies intent to buy more — pre-select the "Buy 2" tier
      // so the second can is one tap closer. click() fires the change/input
      // events flash-forward.js listens for (button text, +/- buttons).
      const tier2 = root.querySelector(
        ".koala-deal__tiers__list > li:nth-child(2) .koala-deal__tier__input"
      );
      if (tier2 && !tier2.checked) tier2.click();
    });
  }

  const tier1Title = root.dataset.tier1Title || "";
  const tier1Subtitle = root.dataset.tier1Subtitle || "";

  let observer;

  function applyTierState() {
    const firstTier = root.querySelector(".koala-deal__tiers__list > li:first-child");
    if (!firstTier) return;

    // The reveal link only makes sense once Koala has rendered tiers.
    root.classList.add("pov2--has-tiers");

    const title = firstTier.querySelector(".koala-deal__tier__title");
    const subtitle = firstTier.querySelector(".koala-deal__tier__subtitle");
    const titleStale = title && tier1Title && title.textContent !== tier1Title;
    const subtitleStale = subtitle && tier1Subtitle && subtitle.textContent !== tier1Subtitle;
    if (!titleStale && !subtitleStale) return;

    // Disconnect while writing so our own mutations don't re-trigger us.
    if (observer) observer.disconnect();
    if (titleStale) title.textContent = tier1Title;
    if (subtitleStale) subtitle.textContent = tier1Subtitle;
    if (observer) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  observer = new MutationObserver(applyTierState);
  observer.observe(document.body, { childList: true, subtree: true });
  applyTierState();
});
